import { messgeraettyp } from '../../../../utils/apiTypes';
import { messgeraettypState } from "./messgeraettypenTypes";
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { getWithAuth, putWithAuth, deleteWithAuth, postJsonWithAuth } from "../../../../utils/api";
import type { RootState, AppDispatch } from "../../../../app/store";
import { logError } from "../../../../utils/utils";
import { openSnackbar } from "../../../../features/snackbar/globalSnackbarSlice";
import { GridSortModel } from '@material-ui/data-grid';
import { errorHandler } from '../../../../utils/errorHandling';

export const messgeraettypDummy: messgeraettyp
  = {
  id: 0,
  typ: "",
  hersteller: "",
  kommentar: "",
  zugeordnet: false,
  rauschgrenzeStrom: 0,
  rauschgrenzeSpannung: 0,
};

const initialState: messgeraettypState
  = {
  messgeraettypListe: [],
  altesMessgeraettyp: messgeraettypDummy,
  aktuellesMessgereattyp: messgeraettypDummy,
  newEntry: false,
  editEntry: false,
  editDirty: 0,
  viewMode: false,
  error: [],
  listLoading: false,
  sorting: [
    {
      field: 'hersteller',
      sort: 'asc',
    },
  ]
};

const messgeraettypenSlice = createSlice({
  name: "messgeraettyp",
  initialState,
  reducers:
  {
    updateMessgeraettypen: (state, action: PayloadAction<messgeraettyp>) => {
      const updateIndex = state.messgeraettypListe.findIndex(
        (x: messgeraettyp) => x.id == action.payload.id
      );
      const firstPart = state.messgeraettypListe.slice(0, updateIndex);
      let lastPart = Array<messgeraettyp>();
      if (updateIndex + 1 < state.messgeraettypListe.length)
        lastPart = state.messgeraettypListe.slice(updateIndex + 1);
      state.messgeraettypListe = [...firstPart, action.payload, ...lastPart].sort((a, b) => a.typ.localeCompare(b.typ));
    },
    removeFromMessgeraettypen: (state, action: PayloadAction<messgeraettyp>) => {
      const updateIndex = state.messgeraettypListe.findIndex(
        (x) => x.id == action.payload.id
      );
      const firstPart = state.messgeraettypListe.slice(0, updateIndex);
      let lastPart = Array<messgeraettyp>();
      if (updateIndex + 1 < state.messgeraettypListe.length)
        lastPart = state.messgeraettypListe.slice(updateIndex + 1);
      state.messgeraettypListe = [...firstPart, ...lastPart];
    },
    addAktuellesMessgeraettypToMessgeraettypen: (state) => {
      const messgeraettypArray = state.messgeraettypListe;
      messgeraettypArray.push(state.aktuellesMessgereattyp);
      state.messgeraettypListe = [...messgeraettypArray].sort((a, b) => a.typ.localeCompare(b.typ));
    },
    setMessgeraettypen: (state, action: PayloadAction<Array<messgeraettyp>>) => {
      state.messgeraettypListe = action.payload;
    },
    setIdAktuellesMessgeraettyp: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereattyp.id = action.payload;
    },
    setAktuellesMessgeraettyp: (state, action: PayloadAction<messgeraettyp>) => {
      state.aktuellesMessgereattyp = action.payload;
      state.altesMessgeraettyp = action.payload;
    },
    setAltesMessgeraettyp: (state, action: PayloadAction<messgeraettyp>) => {
      state.altesMessgeraettyp = action.payload;
    },
    resetAktuellesMessgeraettyp: (state) => {
      state.aktuellesMessgereattyp = state.altesMessgeraettyp;
    },
    setEditEntry: (state) => {
      state.editEntry = true;
    },
    resetEditEntry: (state) => {
      state.editEntry = false;
    },
    setNewEntry: (state) => {
      state.newEntry = true;
    },
    resetNewEntry: (state) => {
      state.newEntry = false;
    },
    resetEditDirty: (state) => {
      state.editDirty = 0;
    },
    setViewMode: (state) => {
      state.viewMode = true;
    },
    resetViewMode: (state) => {
      state.viewMode = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      if (!state.error.includes(action.payload)) {
        state.error.push(action.payload);
      }
    },
    resetError: (state, action: PayloadAction<string>) => {
      if (state.error.includes(action.payload)) {
        state.error.splice(state.error.indexOf(action.payload), 1)
      }
    },
    setId: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereattyp.id = action.payload;
      state.editDirty =
        state.aktuellesMessgereattyp.id ==
          state.altesMessgeraettyp.id
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setTyp: (state, action: PayloadAction<string>) => {
      state.aktuellesMessgereattyp.typ = action.payload;
      state.editDirty =
        state.aktuellesMessgereattyp.typ ==
          state.altesMessgeraettyp.typ
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setRauschgrenzeStrom: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereattyp.rauschgrenzeStrom = action.payload;
      state.editDirty =
        state.aktuellesMessgereattyp.rauschgrenzeStrom ==
          state.altesMessgeraettyp.rauschgrenzeStrom
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setRauschgrenzeSpannung: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereattyp.rauschgrenzeSpannung = action.payload;
      state.editDirty =
        state.aktuellesMessgereattyp.rauschgrenzeSpannung ==
          state.altesMessgeraettyp.rauschgrenzeSpannung
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setHersteller: (state, action: PayloadAction<string>) => {
      state.aktuellesMessgereattyp.hersteller = action.payload;
      state.editDirty =
        state.aktuellesMessgereattyp.hersteller ==
          state.altesMessgeraettyp.hersteller
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKommentar: (state, action: PayloadAction<string>) => {
      state.aktuellesMessgereattyp.kommentar = action.payload;
      state.editDirty =
        state.aktuellesMessgereattyp.kommentar ==
          state.altesMessgeraettyp.kommentar
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setListLoading: (state, action: PayloadAction<boolean>) => {
      state.listLoading = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortModel>) => {
      state.sorting = action.payload;
    },
  }
});


//Selectors
//======================================================================
export const selectMessgeraettypListe = (state: RootState): Array<messgeraettyp> => state.messgeraettyp.messgeraettypListe;
export const selectAktuellesMessgeraettyp = (state: RootState): messgeraettyp => state.messgeraettyp.aktuellesMessgereattyp;
export const selectEditEntry = (state: RootState): boolean => state.messgeraettyp.editEntry;
export const selectNewEntry = (state: RootState): boolean => state.messgeraettyp.newEntry;
export const selectEditDirty = (state: RootState): number => state.messgeraettyp.editDirty;
export const selectViewMode = (state: RootState): boolean => state.messgeraettyp.viewMode;
export const selectError = (state: RootState): boolean => state.messgeraettyp.error.length > 0;
export const selectListLoading = (state: RootState): boolean => state.messgeraettyp.listLoading;
export const selectSorting = (state: RootState): GridSortModel => state.messgeraettyp.sorting;

//Actions
//=====================================================================

export const getMessgeraettypen = () => (dispatch: AppDispatch): void => {
  dispatch(setListLoading(true));
  getWithAuth("MESSGERAETTYP", {})
    .then((response) => {
      dispatch(setMessgeraettypen(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const updateMessgeraettyp = (aktuellesMessgeraettyp: messgeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth("MESSGERAETTYPID", {}, aktuellesMessgeraettyp, aktuellesMessgeraettyp.id.toString())
    .then(() => {
      dispatch(
        openSnackbar({
          message: `Messgerättyp ${aktuellesMessgeraettyp.typ} wurde erfolgreich geändert.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setAltesMessgeraettyp(aktuellesMessgeraettyp));
      dispatch(updateMessgeraettypen(aktuellesMessgeraettyp));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const updateAktuellesMessgeraettyp = (aktuellesMessgeraettyp: messgeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setAktuellesMessgeraettyp(aktuellesMessgeraettyp));
  dispatch(setViewMode());
};

export const discardChanges = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesMessgeraettyp());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
};

export const discardNew = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesMessgeraettyp());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
  dispatch(resetViewMode());
};

export const startNewEntry = () => (dispatch: AppDispatch): void => {
  dispatch(setNewEntry());
  dispatch(setAktuellesMessgeraettyp(messgeraettypDummy));
  dispatch(setEditEntry());
  dispatch(setViewMode());
};

export const createMessgeraettyp = (aktuellesMessgeraettyp: messgeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  postJsonWithAuth("MESSGERAETTYP", {}, {
    id: aktuellesMessgeraettyp.id,
    typ: aktuellesMessgeraettyp.typ,
    hersteller: aktuellesMessgeraettyp.hersteller,
    kommentar: aktuellesMessgeraettyp.kommentar,
    zugeordnet: aktuellesMessgeraettyp.zugeordnet,
    rauschgrenzeStrom: aktuellesMessgeraettyp.rauschgrenzeStrom,
    rauschgrenzeSpannung: aktuellesMessgeraettyp.rauschgrenzeSpannung
  })
    .then((response) => {
      dispatch(
        openSnackbar({
          message: `Messgerättyp ${aktuellesMessgeraettyp.typ} wurde erfolgreich angelegt.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setIdAktuellesMessgeraettyp(response));
      dispatch(addAktuellesMessgeraettypToMessgeraettypen());
      dispatch(setAktuellesMessgeraettyp(messgeraettypDummy));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const deleteMessgeraettyp = (aktuellesMessgeraettyp: messgeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  deleteWithAuth("MESSGERAETTYPID", {}, aktuellesMessgeraettyp.id.toString())
    .then(() => {
      dispatch(setAktuellesMessgeraettyp(messgeraettypDummy));
      dispatch(removeFromMessgeraettypen(aktuellesMessgeraettyp));
      dispatch(resetEditEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
      dispatch(openSnackbar({
        message: `Messgerättyp ${aktuellesMessgeraettyp.typ} wurde erfolgreich gelöscht.`,
        severity: "success",
        duration: 6000,
      }));
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const {
  removeFromMessgeraettypen,
  setMessgeraettypen,
  setAktuellesMessgeraettyp,
  resetAktuellesMessgeraettyp,
  setAltesMessgeraettyp,
  updateMessgeraettypen,
  setEditEntry,
  resetEditEntry,
  setNewEntry,
  resetNewEntry,
  resetEditDirty,
  setViewMode,
  resetViewMode,
  setError,
  resetError,
  setTyp,
  setHersteller,
  setId,
  setRauschgrenzeSpannung,
  setRauschgrenzeStrom,
  setKommentar,
  setIdAktuellesMessgeraettyp,
  addAktuellesMessgeraettypToMessgeraettypen,
  setListLoading,
  setSorting
} = messgeraettypenSlice.actions;
export default messgeraettypenSlice.reducer;